import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["flashNoticeTranslationContainer", "flashNoticeTranslationId"];
    
    flashNoticeTranslationId = null

    connect() {
        this.flashNoticeTranslationId = this.flashNoticeTranslationIdTarget.innerHTML
        const flashRead = window.localStorage.getItem(`ReadFlashNoticeTranslation_${this.flashNoticeTranslationId}`);
        if (flashRead?.toString() !== 'read') {
            this.flashNoticeTranslationContainerTarget.classList.remove('d-none');
            this.flashNoticeTranslationContainerTarget.classList.add('d-flex');
        }

    }

    handleClick() {
        this.flashNoticeTranslationContainerTarget.classList.remove('d-flex');
        this.flashNoticeTranslationContainerTarget.classList.add('d-none');
        window.localStorage.setItem(`ReadFlashNoticeTranslation_${this.flashNoticeTranslationId}`, 'read')
    }
}